import { render } from "./OtpInputPage.vue?vue&type=template&id=27438ba4&scoped=true"
import script from "./OtpInputPage.vue?vue&type=script&lang=js"
export * from "./OtpInputPage.vue?vue&type=script&lang=js"

import "./OtpInputPage.vue?vue&type=style&index=0&id=27438ba4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27438ba4"]])

export default __exports__